module.exports = __webpack_public_path__ + "img/12.c0406d08.png";